// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --ds-filespace-details-data-label-color: var(--ds-color-grey-10);
    --ds-filespace-details-data-value-color: var(--ds-color-grey-10);
}

.FilespaceDetailsWebModalTable-module__Table__XL_Lu {
    max-height: 80%;
}

.FilespaceDetailsWebModalTable-module__DataLabel__nRnMR {
    color: var(--ds-filespace-details-data-label-color);
}

.FilespaceDetailsWebModalTable-module__DataValue__Pm4eJ {
    color: var(--ds-filespace-details-data-value-color);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Table": `FilespaceDetailsWebModalTable-module__Table__XL_Lu`,
	"DataLabel": `FilespaceDetailsWebModalTable-module__DataLabel__nRnMR`,
	"DataValue": `FilespaceDetailsWebModalTable-module__DataValue__Pm4eJ`
};
export default ___CSS_LOADER_EXPORT___;
